import { useEffect } from 'react'
import { Helmet } from 'react-helmet'

import { getLang } from '../localization/utils/localization'
import AnimatedBackground from './AnimatedBackground'
import FdHelmet from './FdHelmet'
import Footer from './Footer'

export interface Props {
  title: string
  subtitle?: string
  children: React.ReactNode
  scroolToTop?: boolean
}

export default function PageBase({ title, subtitle, children, scroolToTop = false }: Props) {
  useEffect(() => {
    if (scroolToTop) window.scrollTo(0, 0)
  }, [scroolToTop])

  return (
    <>
      <FdHelmet HeadElement={Helmet} title={`${title} - Magie Krasy`} lang={getLang()} />
      <section className="min-h-screen px-8 pt-12 pb-32">
        <div className="m-auto max-w-2xl">
          <h1>{title}</h1>
          {subtitle && <h2>✨ {subtitle} ✨</h2>}
          {children}
        </div>
      </section>
      <Footer />
      <AnimatedBackground />
    </>
  )
}
